var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('r-select',{attrs:{"error":_vm.error,"disabled":_vm.disabled,"options":_setup.months},on:{"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_setup.month),callback:function ($$v) {_setup.month=$$v},expression:"month"}})
}
var staticRenderFns = []

export { render, staticRenderFns }